import ListSelect from 'common/components/selectors/ListSelect';
import { FormState } from 'common/entities/form/FormTypes';
import { DrawerState } from 'common/entities/drawer/DrawerTypes';

import { useFormState } from 'utils/hooks';
import GroupField from '../components/GroupField';

const Company = ({ formState, drawer }) => {
  const { fields, selectField } = useFormState(formState);

  return (
    <div className="d-flex flex-column">
      <ListSelect
        list="organizations"
        label={'Company'}
        isAsync
        onChange={e => {
          selectField('organization')(e);
          selectField('store_group')(null);
        }}
        getOptionValue={option => option.id}
        getOptionLabel={option => option.name}
        placeholder="Select company"
        {...fields.organization}
      />

      {drawer?.isOpen ? (
        <GroupField
          onChange={selectField('store_group')}
          key={fields?.organization?.value?.id}
          disabled={!fields?.organization?.value?.id}
          endpoint={
            fields?.organization?.value?.id
              ? `organizations/${fields.organization.value.id}/purchasing-groups`
              : null
          }
          storeGroup={fields?.store_group}
        />
      ) : null}
    </div>
  );
};

export default Company;

Company.propTypes = {
  formState: FormState,
  drawer: DrawerState.isRequired
};
